import { smartAccountClientMethodKeys } from "./decorators/smartAccountClient.js";
export function isSmartAccountClient(client) {
    for (const key of smartAccountClientMethodKeys) {
        if (!(key in client)) {
            return false;
        }
    }
    return client && "middleware" in client;
}
export function isBaseSmartAccountClient(client) {
    return client && "middleware" in client;
}
//# sourceMappingURL=isSmartAccountClient.js.map